import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface GLAccountResponse {
    id?: number | null;
    acc_code?: string | null;
    acc_name?: string | null;
    acc_branch_id?: string | null;
    acc_crat?: string | null;
    acc_crby?: string | null;
    acc_mdat?: string | null;
    acc_mdby?: string | null;
    status?: number | boolean | null;
}

export type GLAccountCreateUpdateRequest = Omit<GLAccountResponse, "id" | "acc_crat" | "acc_crby" | "acc_mdat" | "acc_mdby">;

export const getAllGLAccounts = async (): Promise<GLAccountResponse[]> => {
    try {
        const response: ApiResponse<GLAccountResponse[] | null> = (
            await apiClient.get("/pos_gl_accounts/all", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch GL accounts");
    }
};

export const createGLAccount = async (accountData: GLAccountCreateUpdateRequest): Promise<GLAccountResponse> => {
    try {
        const response: ApiResponse<GLAccountResponse> = (
            await apiClient.post("/pos_gl_accounts/create", accountData, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        if (!response.data) {
            throw new Error("Failed to create GL account - no data returned");
        }

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to create GL account");
    }
};

export const updateGLAccount = async (accountId: number, accountData: GLAccountCreateUpdateRequest): Promise<GLAccountResponse> => {
    try {
        const response: ApiResponse<GLAccountResponse> = (
            await apiClient.put(`/pos_gl_accounts/update/${accountId}`, accountData, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        if (!response.data) {
            throw new Error("Failed to update GL account - no data returned");
        }

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to update GL account");
    }
};